import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle',
                // share: 'share'
            }
        }

        this.shareLinks = this.$('share')

        this.shareBind = this.share.bind(this)
        for(let share of Array.from(this.shareLinks)) {
            share.addEventListener('click', this.shareBind)
        }
    }

    toggle() {
        this.el.classList.toggle('is-active')
    }

    share(e) {
        e.preventDefault();

        const el = e.currentTarget;
        const platform = this.getData('platform', el)
        const url = this.getData('url', el)
        let shareUrl;

        switch(platform) {

            case 'facebook':
                shareUrl = 'https://facebook.com/sharer/sharer.php?u=' + url;
                this.openWindow(shareUrl);
                break;

            case 'twitter':
                shareUrl = 'https://twitter.com/share?url=' + url
                         + '&amp;text=' + encodeURIComponent(this.getData('text', el))
                this.openWindow(shareUrl);
                break;

            case 'mail':
                const subject = encodeURIComponent(this.getData('subject', el))
                const body = encodeURIComponent(this.getData('body', el))
                this.openMail(subject, body);
                break;

        }
    }

    openWindow(url) {
        window.open(url, 'Share', 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=500, width=600');
    }

    openMail(subject, body) {
        window.location = 'mailto:?subject=' + subject + '&body=' + body;
    }

    destroy() {
        super.destroy()

        for(let share of Array.from(this.shareLinks)) {
            share.removeEventListener('click', this.shareBind)
        }
    }
}
